import React from "react";

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught an unhandled error:", error, errorInfo);
  }

  handleReload = () => {
    // Clear potentially corrupt session keys and force reload
    try {
      window.sessionStorage.removeItem("vivashri_chunk_force_refreshed");
    } catch (e) {}
    window.location.reload();
  };

  handleGoHome = () => {
    window.location.href = "/";
  };

  render() {
    if (this.state.hasError) {
      if (this.props.fallback) {
        return this.props.fallback;
      }

      return (
        <div style={styles.container}>
          <div style={styles.card}>
            <div style={styles.iconWrapper}>
              <i className="fa-solid fa-rotate-right" style={styles.icon}></i>
            </div>
            <h2 style={styles.title}>Something went wrong</h2>
            <p style={styles.message}>
              We updated the application or encountered a temporary connection issue. Please refresh the page to continue.
            </p>
            <div style={styles.buttonGroup}>
              <button
                type="button"
                onClick={this.handleReload}
                style={styles.primaryBtn}
              >
                Refresh Page
              </button>
              <button
                type="button"
                onClick={this.handleGoHome}
                style={styles.secondaryBtn}
              >
                Go to Home
              </button>
            </div>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

const styles = {
  container: {
    minHeight: "70vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding: "20px",
    fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif",
  },
  card: {
    maxWidth: "460px",
    width: "100%",
    background: "#ffffff",
    borderRadius: "16px",
    padding: "36px 28px",
    textAlign: "center",
    boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
    border: "1px solid #f0f0f0",
  },
  iconWrapper: {
    width: "60px",
    height: "60px",
    borderRadius: "50%",
    backgroundColor: "#fff0f5",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 20px auto",
  },
  icon: {
    fontSize: "24px",
    color: "#ff3366",
  },
  title: {
    fontSize: "22px",
    fontWeight: "700",
    color: "#222222",
    marginBottom: "12px",
  },
  message: {
    fontSize: "14px",
    color: "#666666",
    lineHeight: "1.6",
    marginBottom: "28px",
  },
  buttonGroup: {
    display: "flex",
    gap: "12px",
    justifyContent: "center",
    flexWrap: "wrap",
  },
  primaryBtn: {
    background: "#ff3366",
    color: "#ffffff",
    border: "none",
    borderRadius: "8px",
    padding: "12px 24px",
    fontSize: "14px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "background 0.2s",
  },
  secondaryBtn: {
    background: "#f7f7f7",
    color: "#333333",
    border: "1px solid #e0e0e0",
    borderRadius: "8px",
    padding: "12px 20px",
    fontSize: "14px",
    fontWeight: "500",
    cursor: "pointer",
  },
};

export default ErrorBoundary;
